export const validateWhitespace = (value: string | number) =>
  !!String(value).trim() || "Can't contain only whitespace";
